import * as React from 'react';
import { createContext, useContext } from 'react';

const ProfileSectionsContext = /*#__PURE__*/ createContext(null);
ProfileSectionsContext.displayName = 'ProfileSectionsContext';
const useProfileSections = ()=>{
    const context = useContext(ProfileSectionsContext);
    if (context === null) {
        // Don't throw here as extra ProfileSections are optional for opcos
        return {};
    }
    return context;
};
const ProfileSectionsProvider = ({ value , children  })=>{
    return /*#__PURE__*/ React.createElement(ProfileSectionsContext.Provider, {
        value: value
    }, children);
};

export { ProfileSectionsContext, ProfileSectionsProvider, useProfileSections };
//# sourceMappingURL=ProfileSectionsContext.js.map
